<template lang="pug">
Auth(:redirectWithLoginFailed="true")
  Header(:content="headerContent")
  div.wrap-edit-comic-episodes
    ModuleEditComicEpisodes(v-if="comic" 
      :comic="comic" :episodes="episodes"
      @updateEpisodes="updateEpisodes")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-edit-comic-episodes {
  width: 100%;
  min-height: $device_height;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header'
import ModuleEditComicEpisodes from '@/components/module/ModuleEditComicEpisodes'

export default {
  components: {
    Auth,
    Header,
    ModuleEditComicEpisodes
  },
  data () {
    return {
      comic: null,
      episodes: [],
      // user: null,
      headerContent: {}
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  async created () {
    this.updateEpisodes()

    const rp = this.$route.params
    this.comic = await database.comicCollection().findById(rp.comicId)
    // this.user = await database.userCollection().findById(this.comic.createdBy)

    this.headerContent = {
      title: this.comic.title,
      left: {
        icon: 'mdi-chevron-left',
        action: this.toUserPage
      },
      // right: {
      //   // icon: 'mdi-account',
      //   avatar: this.user.iconPhotoURL,
      //   action: this.toUserPage
      // }
    }
  },
  methods: {
    async updateEpisodes () {
      // MEMO: なぜかエピソードを削除すると Uncaught Error in snapshot listener がでることがある
      this.episodes = []
      const allEpisodes = await database
        .episodeCollection(this.$route.params.comicId).all()
      if (!allEpisodes[0]) return
      
      // episode.prevに基づいて順番を揃える
      let resultEpisodes = []
      const rootEpisode = allEpisodes.filter(a => !a.prev)[0]
      resultEpisodes.push(rootEpisode)
      let currentEpisodeId = rootEpisode.id
      
      // for (;;) {
      for (let i=0; i<100000; i++) {
        const nextEpisode = allEpisodes
          .filter(a => a.prev === currentEpisodeId)[0]
        if (!nextEpisode) break
        resultEpisodes.push(nextEpisode)
        currentEpisodeId = nextEpisode.id
      }

      this.episodes = resultEpisodes
    },
    toUserPage () {
      this.$router.push(`/user/${this.uid}`)
    }
  }
}
</script>
